
import rexps from '../../validation/regexps.js';
import _ from 'lodash';

const portbounders = (value) => (value > 0 && value <= 65535);
const numericval = (value ) => { return !isNaN(value) };


export { portbounders,numericval };

export function repoid(value) {

    var that = this;
    if (_.isNull(value) || _.isUndefined(value) || value.length === 0) {
        return true;
    }

    if (!rexps.float.test(value)) {
        return false;
    }

    const repoid = parseFloat(value);

    if (repoid < 1 ) {
        return false;
    }

    return true;
}

export function duplication(value) {
    var that = this;
    const rowNum = that.editRow;
    const items = that.rows;
    var i = 0;
    for(i=0;i<items.length; i++)
    {
        if(i!=rowNum)
        {
            const id = items[i].repositoryId;
            if(id == value)
            {
                return false;
            }
        }
    }
    if(that.validationOptions && that.validationOptions.length>0)
    {
        i = 0;
        for(i=0;i<that.validationOptions.length; i++)
        {
            if(i!=rowNum)
            {
                const id = that.validationOptions[i];
                if(id == value)
                {
                    return false;
                }
            }
        }
    }
  
    return true;
}

export function connectionsettings(value) {
    var that = this;
    const rowNum = that.editRow;
    const settings = that.$parent.settings;
    if(settings)
    {
        const item = settings[rowNum];
        if(item)
        {
            if (item.mandatory == 1 || item.mandatory == '1')
            {
                if(value == undefined || value == null || value=='')
                {
                    return false;
                }
                const varval = value.toString().trim();
                if(varval == '')
                {
                    return false;
                }
            }

            //validate type
            if(item.type == 'int')
            {
                const varval = value.toString().trim();
                if(varval != '')
                {
                    const isInteger = !isNaN(value);
                    if( isInteger == false)
                        return false;
                    
                    if(item.minValue != null && item.minValue != undefined)
                    {
                        if(parseInt(item.minValue) > parseInt(value))
                            return false;
                    }

                    if(item.maxValue != null && item.maxValue != undefined)
                    {
                        if(parseInt(item.maxValue) < parseInt(value))
                            return false;
                    }
                }
            }
        }
    }
    return true;
 
}

